import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { handleCanvasCallback, fetchCanvasCourses } from '../utils/canvasApi';

const CanvasCallback = ({ addClass }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get('code');

    if (code) {
      handleCanvasCallback(code)
        .then(accessToken => fetchCanvasCourses(accessToken))
        .then(courses => {
          courses.forEach(course => addClass(course));
          navigate('/classes');
        })
        .catch(error => {
          console.error('Error during Canvas import:', error);
          navigate('/classes');
        });
    } else {
      navigate('/classes');
    }
  }, [location, addClass, navigate]);

  return <div>Processing Canvas import...</div>;
};

export default CanvasCallback;
